import rolePermit from "./role";
import resizePermit from "./resize";
import loading from "./loading";
function directive(app) {
    app.directive("rolePermit", rolePermit);
    app.directive("resize", resizePermit);
    app.directive("myloading", loading);
}
export default directive;
